module.exports = __webpack_public_path__ + "static/media/sven.d8908745.png";